import { apiPath } from '../../constants';
import {
    axios,
    apiRequestOptions,
    errorRequestHandler,
    transformHttpResponse,
} from 'utils';
import { addSuccessMessage } from '../SnackBar';

export const COMPETITIONS_DELETE_DRAW_REQUEST = 'COMPETITIONS_DELETE_DRAW_REQUEST';
export const COMPETITIONS_DELETE_DRAW_FAILURE = 'COMPETITIONS_DELETE_DRAW_FAILURE';
export const COMPETITIONS_DELETE_DRAW_SUCCESS = 'COMPETITIONS_DELETE_DRAW_SUCCESS';

export const deleteCategoryDraw = data => {
    return function(dispatch) {
        dispatch(request());
        return axios(apiRequestOptions(apiPath.COMPETITION_RESULT.DRAW_DELETE, data))
            .then(transformHttpResponse)
            .then(response => {
                const { category, competition } = data;
                dispatch(success(category, competition));
                dispatch(addSuccessMessage('Draw successfully deleted'));
            })
            .catch(error => transformHttpResponse(error.response))
            .catch(error => {
                dispatch(failure(error));
                dispatch(errorRequestHandler(error));
            });
    }
};

const request = () => ({type: COMPETITIONS_DELETE_DRAW_REQUEST});

const failure = error => ({type: COMPETITIONS_DELETE_DRAW_FAILURE, error,});

const success = (category, competition) => ({type: COMPETITIONS_DELETE_DRAW_SUCCESS, category, competition,});
